import { fetchJSONWithTimeout } from '@noths/polaris-client-utils';

import type { FetchContentGraphQlArgs, FetchContentGraphQlOptions } from './types';

/* https://www.contentstack.com/docs/developers/apis/graphql-content-delivery-api */
export const fetchContentGraphQLWithoutCaching = async (
  { deliveryToken, environment, query, stackAPIKey, variables }: FetchContentGraphQlArgs,
  {
    branch,
    region,
    timeout,
  }: Omit<FetchContentGraphQlOptions, 'cacheKey' | 'cacheTTLInSeconds'> = {},
): Promise<unknown> => {
  const url = new URL(`${region}/stacks/${stackAPIKey}`);

  url.searchParams.set('environment', environment);

  const response = await fetchJSONWithTimeout(url.toString(), {
    method: 'POST',
    body: {
      query,
      ...(variables ? { variables } : {}),
    },
    headers: {
      'Content-Type': 'application/json',
      access_token: deliveryToken,
      ...(branch ? { branch } : {}),
    },
    timeout,
  });

  if (!response.ok) {
    throw new Error(`Error querying Contentstack: bad response (${response.status})`);
  }

  const body = await response.json();

  if (body.errors) {
    throw new Error(`Error querying Contentstack: ${body.errors[0].message}`);
  }

  return body.data;
};
